export default "__VITE_ASSET__277a696e__"